import restful from '../vuex'

const state = {
  ...restful.states('order')
}

const getters = {
  ...restful.getters('order'),
  aggregate_test: (state) =>
    `搜索结果：总计 ${state.meta.first} 笔订单，总销售额为 ${state.meta.second} 元，会员销售额为 ${state.meta.third}`
}

const actions = {
  ...restful.actions('orders')
}

const mutations = {
  ...restful.mutations('order')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
